module.exports = __webpack_public_path__ + "static/img/hangye_2@2x.d479c9c7.png";